/** Generated js for domain-specific scripting
 * by common\modules\domains\helpers\DomainJavascriptWriter
 */

/* Interactie: muis-slepen (touch = native swipe), wheel->horizontaal, pijltjes, klikbescherming, keyboard */
/* Interactie: muis-slepen (touch = native swipe), wheel->horizontaal, pijltjes, klikbescherming, keyboard */
(() => {
  const outer    = document.getElementById('newsScroller');
  const viewport = document.getElementById('newsViewport');
  if (!outer || !viewport) return;

  const track   = viewport.querySelector('.news-slider');
  const prevBtn = outer.querySelector('.news-nav.prev');
  const nextBtn = outer.querySelector('.news-nav.next');

  let isDown = false, startX = 0, startScrollLeft = 0, dragMoved = false;

  /* ✅ Helper: klik je in een (inline) editveld? Dan niets doen. */
  const isEditableTarget = (el) =>
    el && (el.closest('[data-editable]') ||
           el.closest('[contenteditable="true"]') ||
           el.closest('input, textarea'));

  // ===== Drag-to-scroll (alleen muis) =====
  const startDrag = (e) => {
    // ⛔️ Niet slepen starten als je in een editveld klikt
    if (isEditableTarget(e.target)) return;

    if (!e.pointerType || e.pointerType !== 'mouse') return; // touch/pen -> native
    e.preventDefault();
    isDown = true; dragMoved = false;
    startX = e.clientX;
    startScrollLeft = viewport.scrollLeft;
    viewport.classList.add('is-dragging');
    if (e.pointerId != null) viewport.setPointerCapture?.(e.pointerId);
  };

  const moveDrag = (e) => {
    if (!isDown) return;
    const dx = e.clientX - startX;
    if (Math.abs(dx) > 5) dragMoved = true;
    viewport.scrollLeft = startScrollLeft - dx;
    if (window.getSelection && window.getSelection().removeAllRanges) {
      window.getSelection().removeAllRanges();
    }
  };

  const endDrag = (e) => {
    if (!isDown) return;
    isDown = false;
    viewport.classList.remove('is-dragging');
    if (e?.pointerId != null) viewport.releasePointerCapture?.(e.pointerId);
  };

  viewport.addEventListener('pointerdown', startDrag);
  viewport.addEventListener('pointermove',  moveDrag);
  viewport.addEventListener('pointerup',    endDrag);
  viewport.addEventListener('pointerleave', endDrag);

  // Blokkeer native drag buiten editvelden
  viewport.addEventListener('dragstart', (e) => {
    if (!isEditableTarget(e.target)) e.preventDefault();
  });

  // Klikbescherming bij slepen – laat clicks in editvelden gewoon door
  viewport.addEventListener('click', (e) => {
    if (isEditableTarget(e.target)) return;
    if (dragMoved) e.preventDefault();
  }, true);

  // Touchpad/muiswiel -> horizontaal: niet ingrijpen in editvelden
  const wheelToX = (e) => {
    if (isEditableTarget(e.target)) return; // laat standaard gedrag
    if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
      e.preventDefault();
      viewport.scrollLeft += e.deltaY;
    }
  };
  viewport.addEventListener('wheel', wheelToX, { passive: false });
  track.addEventListener('wheel', wheelToX, { passive: false });

  // Pijltjes / keyboard / arrows ongewijzigd
  const step = () => {
    const card = track.querySelector('.news-card');
    if (!card) return viewport.clientWidth * 0.9;
    const styles = getComputedStyle(track);
    const gap = parseFloat(styles.gap || styles.columnGap || 16);
    return card.getBoundingClientRect().width + gap;
  };
  const byStep = (dir) => viewport.scrollBy({ left: step() * dir, behavior: 'smooth' });
  prevBtn.addEventListener('click', () => byStep(-1));
  nextBtn.addEventListener('click', () => byStep(1));

  const updateArrows = () => {
    const max = viewport.scrollWidth - viewport.clientWidth - 1;
    prevBtn.disabled = viewport.scrollLeft <= 0;
    nextBtn.disabled = viewport.scrollLeft >= max;
  };
  viewport.addEventListener('scroll', updateArrows, { passive: true });
  window.addEventListener('resize', updateArrows);
  updateArrows();

  viewport.setAttribute('tabindex','0');
  viewport.addEventListener('keydown', (e) => {
    if (e.key === 'ArrowRight') { e.preventDefault(); byStep(1); }
    if (e.key === 'ArrowLeft')  { e.preventDefault(); byStep(-1); }
  });
})();



/* before after slider */
class BeforeAfter {
    constructor(enteryObject) {

        const beforeAfterContainer = document.querySelector(enteryObject.id);
        const before = beforeAfterContainer.querySelector('.bal-before');
        const beforeText = beforeAfterContainer.querySelector('.bal-beforePosition');
        const afterText = beforeAfterContainer.querySelector('.bal-afterPosition');
        const handle = beforeAfterContainer.querySelector('.bal-handle');
        var widthChange = 0;

        beforeAfterContainer.querySelector('.bal-before-inset').setAttribute("style", "width: " + beforeAfterContainer.offsetWidth + "px;")
        window.onresize = function () {
            beforeAfterContainer.querySelector('.bal-before-inset').setAttribute("style", "width: " + beforeAfterContainer.offsetWidth + "px;")
        }
        before.setAttribute('style', "width: 50%;");
        handle.setAttribute('style', "left: 50%;");

        //touch screen event listener
        beforeAfterContainer.addEventListener("touchstart", (e) => {

            beforeAfterContainer.addEventListener("touchmove", (e2) => {
                let containerWidth = beforeAfterContainer.offsetWidth;
                let currentPoint = e2.changedTouches[0].clientX;

                let startOfDiv = beforeAfterContainer.offsetLeft;

                let modifiedCurrentPoint = currentPoint - startOfDiv;

                if (modifiedCurrentPoint > 10 && modifiedCurrentPoint < beforeAfterContainer.offsetWidth - 10) {
                    let newWidth = modifiedCurrentPoint * 100 / containerWidth;

                    before.setAttribute('style', "width:" + newWidth + "%;");
                    afterText.setAttribute('style', "z-index: 1;");
                    handle.setAttribute('style', "left:" + newWidth + "%;");
                }
            });
        });

        //mouse move event listener
        beforeAfterContainer.addEventListener('mousemove', (e) => {
            let containerWidth = beforeAfterContainer.offsetWidth;
            widthChange = e.offsetX;
            let newWidth = widthChange * 100 / containerWidth;

            if (e.offsetX > 10 && e.offsetX < beforeAfterContainer.offsetWidth - 10) {
                before.setAttribute('style', "width:" + newWidth + "%;");
                afterText.setAttribute('style', "z-index:" + "1;");
                handle.setAttribute('style', "left:" + newWidth + "%;");
            }
        })

    }
}
if (document.querySelector('#beforeafterslider')) {
    new BeforeAfter({
        id: '#beforeafterslider'
    });
}

/* expander */
document.addEventListener('click', function (event) {
  var isExpandButton = event.target.matches('expand-button') || event.target.closest('.expand-button') != null;
  var expanderParent = event.target.closest('.expander');
  if (isExpandButton && expanderParent !== null) {
    event.preventDefault();
    toggleExpander(expanderParent, true);
  }
});
var toggleExpander = function toggleExpander(expanderElement, toggle) {
  if (toggle) {
    expanderElement.classList.toggle('expand');
  }
  var maxHeight = "999em";
  if (!expanderElement.classList.contains('expand')) {
    var _expanderElement$data;
    maxHeight = (_expanderElement$data = expanderElement.dataset.minimalHeight) !== null && _expanderElement$data !== void 0 ? _expanderElement$data : "50px";
  }
  var contentElement = expanderElement.querySelector('.expander-content');
  contentElement.style.maxHeight = maxHeight;
};
var expanders = document.querySelectorAll('.expander');
var _iterator = _createForOfIteratorHelper(expanders),
  _step;
try {
  for (_iterator.s(); !(_step = _iterator.n()).done;) {
    var expander = _step.value;
    toggleExpander(expander, false);
  }
} catch (err) {
  _iterator.e(err);
} finally {
  _iterator.f();
}